// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { createAction } from '@reduxjs/toolkit';
import type { ChatMessage } from './chatbotTypes';

// One chat turn (POST gdb-chat). Start optimistically shows the user's message + spins; Success swaps in
// the transcript with Khora's reply; Failure records the error; Done releases the input (loading off).
// loading is bracketed by Start(on)/Done(off) so it can never stick — Done fires from the thunk's finally.
export const SendChatTurnStartAction = createAction<ChatMessage[]>('chatbot/SendChatTurnStartAction');
export const SendChatTurnSuccessAction = createAction<ChatMessage[]>('chatbot/SendChatTurnSuccessAction');
export const SendChatTurnFailureAction = createAction<string>('chatbot/SendChatTurnFailureAction');
export const SendChatTurnDoneAction = createAction('chatbot/SendChatTurnDoneAction');

// The live "what Khora is doing right now" status, polled per turn (null → the ThinkingIndicator falls
// back to its timed approximation).
export const SetChatProgressAction = createAction<string | null>('chatbot/SetChatProgressAction');

// Session (per gdb version): restore hydrates the saved transcript + the "newer version exists" hint;
// reset wipes the transcript when the gdb/order switches (BEFORE the new one's restore); stale toggles
// the dismissable chip.
export const RestoreSessionAction = createAction<{ messages: ChatMessage[]; stale: boolean }>('chatbot/RestoreSessionAction');
export const ResetSessionAction = createAction('chatbot/ResetSessionAction');
export const SetSessionStaleAction = createAction<boolean>('chatbot/SetSessionStaleAction');

// Clear the conversation (transcript + error); leaves the stale hint untouched.
export const ClearChatAction = createAction('chatbot/ClearChatAction');
